<template>
  <b-modal
    @hide="hide"
    ref="diff-modal"
    id="diff-modal"
    size="lg"
    title="Logged Changes"
  >
    <template slot="default">
      <div class="row" v-if="this.currentOrder">
        <div class="col col-md-3">
          <b-nav vertical>
            <b-nav-item v-for="log, ix in logEntries" :key="log.datecreated" @click="changeDiff(ix)">{{log.action.split('(')[0]}}<br> <NiceDate :split="true" :value="String(log.datecreated)" /></b-nav-item>
            <b-nav-item @click="changeDiff(null)">Right Now</b-nav-item>
          </b-nav>
        </div>
        <div class="col col-md-9">
          <pre style="{'max-height': selectedLog ? '57vh' : '85vh'}">{{selectedLog || currentOrder}}</pre>
          <pre v-if="selectedLog">{{flatDiff}}</pre>
        </div>
      </div>
      <div class="row justify-content-center" v-else>
        Loading...
        <fingerprint-spinner
            :animation-duration="1500"
            :size="300"
            color="#293a93"
            class="my-3"
          />
      </div>
    </template>

    <template slot="modal-footer" slot-scope="{hide}">
      <b-button @click="hide()">Close</b-button>
    </template>
  </b-modal>
</template>

<script>
import axios from 'axios';
import { FingerprintSpinner } from 'epic-spinners';
import {deepEntries, delimitEntry} from 'deep-entries';

import NiceDate from '../utility/NiceDate';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  data() {
    return {
      logEntries: [],
      currentOrder: null,
      selectedLog: null,
    }
  },
  props: {
    open: { type: Boolean, default: false},
    soNum: {type: String, default: ''}
  },
  methods: {
    hide() {
      this.$emit('closediff')
      this.logEntries = [];
      this.currentOrder = null;
    },
    changeDiff(ix) {
      console.log('change to ', ix)
      if(this.logEntries[ix]) {
        console.log(this.logEntries[ix])
        this.selectedLog = JSON.parse(this.logEntries[ix].original_json)
      } else {
        this.selectedLog = this.currentOrder
      }
    }
  },
  computed: {
    firstRecord() {
      return this.logEntries.filter( (e) => !! JSON.parse(e.original_json))[0];
    },
    flatFirst() {
      if(this.firstRecord) {
        return deepEntries(JSON.parse(this.firstRecord.original_json), delimitEntry).reduce( (a, v) => {a[v[0]] = v[1]; return a}, {})
      } else {
        return {}
      }
    },
    flatSelected() {
      if(this.selectedLog) {
        return deepEntries(this.selectedLog, delimitEntry).reduce( (a, v) => {a[v[0]] = v[1]; return a}, {})
      } else {
        return null
      }
    },
    flatDiff() {
      if(this.selectedLog) {
        const diffs = {}
        const keyUnion = [...new Set([...Object.keys(this.flatFirst), ...Object.keys(this.flatSelected)])]
        keyUnion.forEach( e => {
          if(this.flatFirst[e] !== this.flatSelected[e]) {
            diffs[e] = [ `is ${this.flatSelected[e]}`, `was ${this.flatFirst[e]}` ]
          }
        })
        return diffs
      } else {
        return {}
      }
    }
  },
  watch: {
    open() {
      if(this.open) {
        this.$refs['diff-modal'].show()
      } else {
        this.$refs['diff-modal'].hide()
      }
    },
    soNum() {
      axios.get(`${BASE_API}/audit/${this.soNum}`).then( r => {
        this.logEntries = r.data;
        axios.get(`${BASE_API}/workarea/order/${this.soNum}`).then( w => {
          this.currentOrder = w.data;
          this.selectedLog = w.data;
        })
      });
    }
  },
  components: {
    FingerprintSpinner,
    NiceDate,
  },
}
</script>

<style scoped>
  pre {
    background-color: #222;
    color: #f8f4f0;
    font-size: 0.66rem;
    max-height: 33vh;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/audit/AuditDiff.vue